/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Standings_Top10Inputs */



/**
* | output |
* | --- |
* | "Top 10" |
*
* @param {Tournament_Standings_Top10Inputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_standings_top10 = /** @type {((inputs?: Tournament_Standings_Top10Inputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Standings_Top10Inputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Top 10")
	if (locale === "es") return /** @type {LocalizedString} */ ("Top 10")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Top 10")
	if (locale === "it") return /** @type {LocalizedString} */ ("Top 10")
	return /** @type {LocalizedString} */ ("Top 10")
});